module.exports = __webpack_public_path__ + "static/media/logo-terese-thulin.8486fed7.svg";